import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import PAAcountInfoM from "./PAAcountInfoM";
import PAAcountInfoW from "./PAAcountInfoW";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class PAAcountInfo extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(PAAcountInfo.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }
  
  render(){
    return ResponsiveX.Split({
      0: () => <PAAcountInfoM/>,
      [SysConfig.WebUIWidth]: () => <PAAcountInfoW/>
    });
  }

}

export default observer(PAAcountInfo);
